// import yourEnhancers from '../path/to/yourEnhancer'

let enhancers = [
	// yourEnhancer,
	// array of enhancers you want to apply
];

export default enhancers;